import { ROUTE_KEYS, ROUTES } from "../constants";
import LogIn from "../../../Authentication/components/LogIn";
import App, { HydrateFallback } from "../../../App/components";
import ErrorBoundary from "../components/ErrorBoundary";
import {
  createBrowserRouter as _createBrowserRouter,
  createRoutesFromElements,
  Outlet,
  Route,
} from "react-router-dom";
import LogOut from "../../../Authentication/components/LogOut";
import anyRolesLoader from "../loaders/roles";
import Unauthorized from "../../../Authentication/components/Unauthorized";
import FormRouteType from "../../../Forms/components/Router/Type";
import FormRouteIdentifier from "../../../Forms/components/Router/Identifier";
import FormRouteIndex from "../../../Forms/components/Router";
import ProtectedRoute from "../components/ProtectedRoute";
import { ROLES } from "../../../util/constants";
import loginLoader from "../loaders/login";
import Submissions from "../../../Submissions/components";
import Dashboard from "../../../Dashboard/components";
import Admin from "../../../Admin/components";
import PreviewForm from "../../../Forms/components/Preview";
import AllSessions from "../../../Admin/components/AllSessions";

export const createCustomBrowserRouter = ({ dispatch, getState }) => {
  const allGMSUsersLoader = ({ context = {}, ...options }) => {
    return anyRolesLoader({
      ...options,
      context: {
        ...context,
        allowedRoles: Object.values(ROLES)
      },
    });
  };
  const adminLoader = ({ context = {}, ...options }) => {
    return anyRolesLoader({
      ...options,
      context: {
        ...context,
        allowedRoles: [ROLES.ADMINS]
      },
    });
  };
  const routeElements = (
    <Route
      element={<App />}
      HydrateFallback={HydrateFallback}
      errorElement={<ErrorBoundary />}
    >
      <Route
        key="unauth"
        path={ROUTES[ROUTE_KEYS.UNAUTH].path}
        element={<Unauthorized />}
        handle={{
          title: ROUTES[ROUTE_KEYS.UNAUTH].title,
        }}
      />
      <Route
        key="login"
        path={ROUTES[ROUTE_KEYS.LOGIN].path}
        element={<LogIn />}
        loader={loginLoader}
        handle={{
          title: ROUTES[ROUTE_KEYS.LOGIN].title,
        }}
      />
      <Route
        key="logout"
        path={ROUTES[ROUTE_KEYS.LOGOUT].path}
        element={<LogOut />}
        handle={{
          title: ROUTES[ROUTE_KEYS.LOGOUT].title,
        }}
      />
      <Route
        key="home"
        path={ROUTES[ROUTE_KEYS.HOME].path}
        element={<Dashboard />}
        handle={{
          title: ROUTES[ROUTE_KEYS.HOME].title,
        }}
      />
      <Route //Must have some supported role in GMS for any of these routes
        loader={allGMSUsersLoader}
        element={<ProtectedRoute />}
      >
        <Route
          key="submissions"
          path={ROUTES[ROUTE_KEYS.SUBMISSIONS].path}
          element={<Submissions />}
          handle={{
            title: ROUTES[ROUTE_KEYS.SUBMISSIONS].title,
          }}
        />
        <Route
          handle={{
            title: ROUTES[ROUTE_KEYS.FORMS].title,
          }}
          path={ROUTES[ROUTE_KEYS.FORMS].path}
          element={<FormRouteIndex />}
        >
          <Route
            handle={{
              title: ROUTES[ROUTE_KEYS.FORMS].title,
            }}
            path={":type?"}
            element={<FormRouteType />}
          >
            <Route
              handle={{
                title: ROUTES[ROUTE_KEYS.FORMS].title,
              }}
              path={":id?"}
              element={<FormRouteIdentifier />}
            />
          </Route>
        </Route>
        <Route
          key="admin"
          loader={adminLoader}
          path={ROUTES[ROUTE_KEYS.ADMIN].path}
          element={<Outlet />}
        >
          <Route
            index
            element={<Admin />}
            handle={{
              title: ROUTES[ROUTE_KEYS.ADMIN].title,
            }}
          />
          <Route
            handle={{
              title: `All Reporting Periods`,
            }}
            path={ROUTES[ROUTE_KEYS.PREVIEW].path}
            element={<AllSessions />}
          />
          <Route
            handle={{
              title: ROUTES[ROUTE_KEYS.PREVIEW].title,
            }}
            path={ROUTES[ROUTE_KEYS.PREVIEW].path + "/" + ROUTES[ROUTE_KEYS.PREVIEW].params}
            element={<PreviewForm />}
          />
        </Route>
      </Route>
      <Route
        path={ROUTES[ROUTE_KEYS.NOT_FOUND].path}
        element={<div>page not found</div>}
        handle={{
          title: ROUTES[ROUTE_KEYS.NOT_FOUND].title,
        }}
      />
    </Route>
  );
  const routes = createRoutesFromElements(routeElements);

  return _createBrowserRouter(routes);
};
